import * as queryString from 'query-string';

export function buildQuery(parameters: Record<string,unknown>): string {

    const queryParameters: Record<string,unknown> = {};
    let query = "";
    // eslint-disable-next-line
    Object.keys(parameters).map(key=> {

        if (parameters[key]!==''){
          queryParameters[key] = parameters[key];
        }

    })

    if (Object.keys(queryParameters).length!==0){
      query = "?" + queryString.stringify(queryParameters);
    }
    return query;
}

export function getQueryParam(key:string, defaultValue: string): string | string[] | null {

    let value: string | string[] | null = defaultValue;
    const inputQuery = queryString.parse(window.location.search, {arrayFormat: 'comma'});

    if (Object.entries(inputQuery).length !== 0 && Object.keys(inputQuery).includes(key) && inputQuery[key]!=null){
      value = inputQuery[key];
    }

    return value;

}

export function getArrayParam(key: string, defaultValue: string[] | number[]) : string[] | number[] {
  // eslint-disable-next-line
  let value: any = defaultValue;
  // eslint-disable-next-line
  const inputQuery: any = queryString.parse(window.location.search, {arrayFormat: 'comma'});

  if (Object.entries(inputQuery).length !== 0 && Object.keys(inputQuery).includes(key) && inputQuery[key]!=null){
    value = value.concat(inputQuery[key]);
  }
  return value;
}
// eslint-disable-next-line
export function updateURLQuery(key: string, value: any): void {
  const inputQuery = queryString.parse(window.location.search, {arrayFormat: 'comma'});
  inputQuery[key] = value;
  const outputQuery = queryString.stringify(inputQuery, {arrayFormat: 'comma'});
  window.history.pushState(null, '', window.location.pathname + `?${outputQuery}`);
}
// eslint-disable-next-line
export function parseLinkHeader( linkHeader: string ) {
  const linkHeadersArray = linkHeader.split( ", " ).map( header => header.split( ";" ) );
  const linkHeadersMap = linkHeadersArray.map( header => {
     const thisHeaderRel = header[1].replace( /"/g, "" ).replace( "rel=", "" );
     const thisHeaderUrl = header[0].slice( 1, -1 );
     return [ thisHeaderRel, thisHeaderUrl ]
  } );
  return Object.fromEntries( linkHeadersMap );
}